module.exports = __webpack_public_path__ + "static/media/skill.f9159629.jpeg";